import React from 'react';
import { CheckCircle2, Circle, ThumbsUp, Ban, ShieldAlert } from 'lucide-react';

function Ring({ done, total }) {
  const pct = total ? done / total : 0;
  const c = 2 * Math.PI * 26;
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" data-testid="recovery-milestone-ring">
      <circle cx="32" cy="32" r="26" fill="none" stroke="#e2e8f0" strokeWidth="7" />
      <circle cx="32" cy="32" r="26" fill="none" stroke="#0f766e" strokeWidth="7" strokeLinecap="round"
              strokeDasharray={c} strokeDashoffset={c * (1 - pct)} transform="rotate(-90 32 32)" style={{ transition: 'stroke-dashoffset .6s ease' }} />
      <text x="32" y="37" textAnchor="middle" fontSize="14" fontWeight="800" fill="#0f172a">{done}/{total}</text>
    </svg>
  );
}

const Card = ({ title, icon, children, testId }) => (
  <section className="rounded-2xl bg-white border border-slate-200 p-4 shadow-sm" data-testid={testId}>
    <h2 className="text-[15px] font-extrabold text-slate-900 flex items-center gap-2">{icon}{title}</h2>
    {children}
  </section>
);

export default function PlanGuide({ plan, reached, day }) {
  const done = plan.milestones.filter((m) => reached[m.id]).length;
  return (
    <>
      <Card title="Recovery milestones" icon={<CheckCircle2 size={17} className="text-teal-700" />} testId="recovery-milestones">
        <div className="mt-2 flex items-center gap-4">
          <Ring done={done} total={plan.milestones.length} />
          <p className="text-[13px] text-slate-600">{plan.summary || 'Tick milestones in your check-in as you reach them.'}</p>
        </div>
        <ul className="mt-3 space-y-2">
          {plan.milestones.map((m) => (
            <li key={m.id} className="flex items-center gap-2 text-[14px]" data-testid={`recovery-milestone-${m.id}`}>
              {reached[m.id] ? <CheckCircle2 size={17} className="text-emerald-600" /> : <Circle size={17} className={day >= m.target_day ? 'text-amber-500' : 'text-slate-300'} />}
              <span className={reached[m.id] ? 'line-through text-slate-400' : 'text-slate-800'}>{m.title}</span>
              <span className="ml-auto text-[11px] font-bold text-slate-400">Day {m.target_day}</span>
            </li>
          ))}
        </ul>
      </Card>
      <div className="grid sm:grid-cols-2 gap-4">
        <Card title="Do's" icon={<ThumbsUp size={16} className="text-emerald-600" />} testId="recovery-dos">
          <ul className="mt-2 list-disc pl-5 text-[14px] space-y-1 text-slate-800">{plan.dos.map((s) => <li key={s}>{s}</li>)}</ul>
        </Card>
        <Card title="Don'ts" icon={<Ban size={16} className="text-red-600" />} testId="recovery-donts">
          <ul className="mt-2 list-disc pl-5 text-[14px] space-y-1 text-slate-800">{plan.donts.map((s) => <li key={s}>{s}</li>)}</ul>
        </Card>
      </div>
      <Card title="Red-flag guide" icon={<ShieldAlert size={17} className="text-amber-600" />} testId="recovery-redflag-guide">
        <ul className="mt-2 space-y-3">
          {plan.red_flags.map((f) => (
            <li key={f.id} className="rounded-xl border border-amber-200 bg-amber-50/60 p-3">
              <div className="text-[14px] font-bold text-amber-900">{f.question}</div>
              <div className="text-[12.5px] text-amber-900/80 mt-1">{f.self_care.join(' · ')} — contact your surgeon if not better in {f.time_limit_hours} h.</div>
            </li>
          ))}
        </ul>
      </Card>
    </>
  );
}
